import { Modal } from 'ant-design-vue'
import { h, createVNode } from 'vue'
import Warn from '@/assets/icon/confirm-tips.svg'
import { StoreUtils } from '@/store/StoreUtil'

export function confirm (props: Record<string, unknown>) {
  const { hideOkButton, hideCancelButton, title } = props
  let isAr = false
  if (StoreUtils.store) {
    isAr = StoreUtils.store.state.global.isArSite
  }
  Modal.confirm({
    // title: 'Tips',
    title: h('div', {}, [
      createVNode('img', { src: Warn, style: 'margin-right: 10px' }),
      createVNode('span', {}, title || 'Tips')
    ]),
    width: '435px',
    closable: true,
    centered: true,
    class: `antd--api--modal--fix ${hideOkButton ? 'antd--api--modal--hide--ok' : ''} ${hideCancelButton ? 'antd--api--modal--hide--cancel' : ''} ${isAr ? 'rtl--container' : ''}`,
    ...props
  })
}
